import { useChatStore } from "@lib/stores/chatStore";
import { useEffect } from "react";
import { useLocation } from "react-router";

interface RouteMatch {
  view: string;
  resource_type?: string;
  resource_id?: string;
  campaign_id?: string;
  outreach_programme_id?: string;
}

export function parseRoute(pathname: string, search: string): RouteMatch {
  const segments = pathname.split("/").filter(Boolean);
  const params = new URLSearchParams(search);

  if (segments[0] === "campaigns" && segments[1] && segments[2] === "candidates" && segments[3]) {
    return {
      view: "campaign_candidate_detail",
      resource_type: "CampaignCandidate",
      resource_id: segments[3],
      campaign_id: segments[1],
    };
  }
  if (segments[0] === "campaigns" && segments[1]) {
    return {
      view: "campaign_detail",
      resource_type: "Campaign",
      resource_id: segments[1],
      campaign_id: segments[1],
    };
  }
  if (segments[0] === "campaigns") {
    return { view: "campaign_list" };
  }
  if (segments[0] === "candidates" && segments[1]) {
    return { view: "candidate_detail", resource_type: "Candidate", resource_id: segments[1] };
  }
  if (segments[0] === "candidates") {
    return { view: "candidate_list" };
  }
  if (segments[0] === "clients" && segments[1]) {
    return { view: "client_detail", resource_type: "Client", resource_id: segments[1] };
  }
  if (segments[0] === "clients") {
    return { view: "client_list" };
  }
  if (segments[0] === "talent-pools" && segments[1]) {
    return { view: "talent_pool_detail", resource_type: "TalentPool", resource_id: segments[1] };
  }
  if (segments[0] === "talent-pools") {
    return { view: "talent_pool_list" };
  }
  if (segments[0] === "settings") {
    return { view: "settings" };
  }
  if (segments[0] === "outreach") {
    const programmeId = params.get("programme") ?? undefined;
    return {
      view: "outreach",
      resource_type: programmeId ? "OutreachProgramme" : undefined,
      resource_id: programmeId,
      outreach_programme_id: programmeId,
    };
  }

  return { view: "dashboard" };
}

export function useChatContext() {
  const location = useLocation();
  const setViewContext = useChatStore((s) => s.setViewContext);

  useEffect(() => {
    const match = parseRoute(location.pathname, location.search);
    setViewContext(match);
  }, [location.pathname, location.search, setViewContext]);
}
